import type { ThemeStyle, Theme } from '@admin/shared/themes/default';

/**
 * Override styles for paper component.
 *
 * @returns {ThemeStyle}
 */
export const getMuiPaperStyle = (theme: Theme): ThemeStyle => {
  return {
    rounded: {
      borderRadius: theme.shape.borderRadius,
    },
  };
};
